import { render } from "./RGPD.vue?vue&type=template&id=5ce60299&scoped=true"
import script from "./RGPD.vue?vue&type=script&lang=js"
export * from "./RGPD.vue?vue&type=script&lang=js"

import "./RGPD.vue?vue&type=style&index=0&id=5ce60299&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ricar\\OneDrive\\Ambiente de Trabalho\\Projetos\\WIP\\Reorganiza\\Leadcenter\\Dashboard\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ce60299"]])

export default __exports__